import { GetUserProfileCourseSort } from '../../../resources/@types/courseSchema';

export function normalizeCourseSort(sort: string): GetUserProfileCourseSort {
  if (
    sort === GetUserProfileCourseSort.RECOMMEND ||
    sort === GetUserProfileCourseSort.RECENT ||
    sort === GetUserProfileCourseSort.POPULAR
  ) {
    return sort;
  }

  return GetUserProfileCourseSort.RECENT;
}
